// extracted by mini-css-extract-plugin
module.exports = {"weighingTicketChart":"WeighingTicketsOverviewChart_weighingTicketChart__2PS6z","chartLabel":"WeighingTicketsOverviewChart_chartLabel__1fDwt"};